import { Dayjs } from 'dayjs';
import MonthRangePicker from './components/MonthRangePicker.component';

interface ICustomMonthRangePicker {
	name: string;
	dates: (Dayjs | null)[];
	error?: boolean;
	errorMessage?: string;
	setStartDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
	setEndDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
	onClose?: () => void;
}

const CustomMonthRangePicker = ({
	name,
	dates,
	error,
	errorMessage,
	setStartDate,
	setEndDate,
	onClose,
}: ICustomMonthRangePicker) => {
	return (
		<MonthRangePicker
			name={name}
			dateStart={dates[0]}
			dateEnd={dates[1]}
			error={error}
			errorMessage={errorMessage}
			setStartDate={setStartDate}
			setEndDate={setEndDate}
			onClose={onClose}
		/>
	);
};

export default CustomMonthRangePicker;
